import { Component, Signal, computed, inject, input, signal } from '@angular/core';
import { LocaleDateProvider } from '@secondaries/scenario/providers/locale-date.provider';
import { MarketArea } from '@scenario/models/market-area.model';
import { RegionManager } from '@scenario/models/region-manager.model';
import { PsfUser } from '@scenario/models/psf-user.model';
import { Source } from '@scenario/models/source.model';
import { dispatch } from '@store/injectables';
import { removeRegionManager } from '@store/scenario/region-manager/region-manager-slice';
import {
  ButtonComponent,
  ModalService,
  SegmentedControlComponent,
  SegmentedControlOptionComponent,
  TileComponent,
} from '@totalenergiescode/tds-angular';
import { RegionManagerFormModalComponent } from '../region-manager-form-modal/region-manager-form-modal.component';
@Component({
  selector: 'app-region-manager-section',
  templateUrl: './region-manager-section.component.html',
  styleUrl: './region-manager-section.component.scss',
  imports: [ButtonComponent, SegmentedControlComponent, SegmentedControlOptionComponent, TileComponent],
})
export class RegionManagerSectionComponent {
  private readonly dispatch = dispatch();
  private readonly dateProvider = new LocaleDateProvider(navigator.language);
  private readonly modalService = inject(ModalService);
  public readonly source = input.required<Source>();
  public readonly marketAreas = input.required<MarketArea[]>();
  public readonly regionManagers = input.required<RegionManager[]>();
  public readonly users = input.required<PsfUser[]>();
  public readonly selectedTab = signal(0);
  public readonly sourceRegionManagers: Signal<RegionManager[]> = computed(() =>
    this.regionManagers().filter(regionManager => regionManager.source?.id === this.source().id),
  );
  public readonly activeRegionManagers: Signal<RegionManager[]> = computed(() =>
    this.sourceRegionManagers().filter(regionManager => !this.isFormer(regionManager)),
  );
  public readonly formerRegionManagers: Signal<RegionManager[]> = computed(() =>
    this.sourceRegionManagers().filter(regionManager => this.isFormer(regionManager)),
  );
  formatDate(date: string | undefined): string {
    return date ? this.dateProvider.convertToLocaleString(date) : '';
  }
  marketAreaLabel(regionManager: RegionManager): string {
    const marketAreaId = regionManager.marketArea?.id;
    return this.marketAreas().find(marketArea => marketArea.id === marketAreaId)?.name
      ?? regionManager.marketArea?.name
      ?? '';
  }

  fullName(regionManager: RegionManager): string {
    return [regionManager.firstName, regionManager.lastName].filter(Boolean).join(' ');
  }
  openCreate(): void {
    this.modalService.open({
      content: {
        component: RegionManagerFormModalComponent,
        inputs: { source: this.source(), users: this.users() },
      },
    });
  }
  remove(regionManager: RegionManager): void {
    if (regionManager.id !== undefined
      && confirm(`Remove ${regionManager.email ?? 'this user'} as Region Manager for ${this.source().name}?`)) {
      this.dispatch(removeRegionManager(regionManager.id));
    }
  }
  private isFormer(regionManager: RegionManager): boolean {
    return !!regionManager.endDate && !!regionManager.removedByEmail;
  }
}
